

// "Fri May 31 2024 00:00:00 GMT+0530 (India Standard Time)" ===>  "31/05/2024"
export function CovertString_TO_DateFormat(currdate) {
    const dateString = currdate;
    const date = new Date(dateString);
    const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    return formattedDate;
}

export function isPastDate(dateString) {
  // Parse the input string into a Date object
  const inputDate = new Date(dateString);
  const today = new Date();

  // Normalize both dates to midnight (ignore time part)
  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return inputDate < today; // true if past date
}


export function openInGoogleMaps(address) {
    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(mapsUrl, '_blank');
};

export const API_BASE_URL = "https://partywitty.com";


export function formatDuration(text) {
  if (!text) return "";

  return text
    .replace(/Hours?/i, "hr")      // Replace "Hour" or "Hours" → "hr"
    .replace(/Minutes?/i, "m")   // Replace "Minute" or "Minutes" → "min"
    .replace(/\s+/g, " ")          // Normalize spaces
    .trim();                       // Remove trailing space
}